import {
  ActionIcon,
  Group,
  Text,
  createStyles
} from "@mantine/core";
import { IconEdit, IconEye, IconTrash } from "@tabler/icons-react";
import swal from "sweetalert";
import { remoteNoteType } from "../../services/note";

const useStyles = createStyles((theme) => ({
  field: {
    borderWidth: 1,
    boderColor: "#232323",
    borderStyle: "solid",
    borderRadius: 8
  }
}));

const NoteTypeTableRow = ({ row, onView, onEdit }) => {
  const { classes } = useStyles();
  const fields = row.custom?.map((field, i) => (
    <Text className={classes.field} p={5} key={i}>
      {field?.field}
    </Text>
  ));
  // functions
  const remove = async (canDelete) => {
    // console.log({ canDelete });
    if (canDelete) {
      const willDelete = await swal({
        title: `Are you sure?`,
        text: "This action cannot be undone. Note Types are further associated to Note, Deleting note type can cause problems.",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancel", "Delete"]
      });
      if (willDelete) remoteNoteType(row?.id);
    } else {
      await swal({
        title: `Delete`,
        text: "You cannot delete this note type. ",
        icon: "warning"
      });
    }
  };
  return (
    <tr style={{ cursor: "pointer" }}>
      <td onClick={() => onView(row)}>{row.name || "-"}</td>
      <td onClick={() => onView(row)}>
        <Group>{fields}</Group>
      </td>
      <td>
        <Group wrap="nowrap">
          {!row?.general && (
            <ActionIcon
              color="yellow"
              variant="light"
              onClick={() => onView(row)}
            >
              <IconEye />
            </ActionIcon>
          )}
          {!row?.general && (
            <ActionIcon color="green" variant="light" onClick={() => onEdit(row)}>
              <IconEdit />
            </ActionIcon>
          )}
          {!row?.general && (
            <ActionIcon
              color="red"
              variant="light"
              onClick={() => remove(row?.canDelete)}
            >
              <IconTrash />
            </ActionIcon>
          )}
        </Group>
      </td>
    </tr>
  );
};

export default NoteTypeTableRow;
